"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.recomNormalizer = void 0;
const mocks_json_1 = __importDefault(require("./mocks.json"));
/**
 * normalizador del modulo MODULO_RECOMENDACION
 * @param {object} fields
 * @returns
 */
const recomNormalizer = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    try {
        let res = null;
        const title = (_a = data === null || data === void 0 ? void 0 : data.fields) === null || _a === void 0 ? void 0 : _a.title;
        const backgroundColor = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.backgroundColor;
        const buttonText = (_c = data === null || data === void 0 ? void 0 : data.fields) === null || _c === void 0 ? void 0 : _c.buttonText;
        const urlLink = (_d = data === null || data === void 0 ? void 0 : data.fields) === null || _d === void 0 ? void 0 : _d.urlLink;
        const layout = ((_e = data === null || data === void 0 ? void 0 : data.fields) === null || _e === void 0 ? void 0 : _e.layout) || "carousel";
        const img = ((_f = data === null || data === void 0 ? void 0 : data.fields) === null || _f === void 0 ? void 0 : _f.img) || "";
        const listadoCards = ((_g = data === null || data === void 0 ? void 0 : data.fields) === null || _g === void 0 ? void 0 : _g["MODULO_RECOMENDACION"]) || ((_h = data === null || data === void 0 ? void 0 : data.fields) === null || _h === void 0 ? void 0 : _h["COMPONET_CARD"]);
        if (listadoCards &&
            Array.isArray(listadoCards) &&
            listadoCards.length > 0) {
            const normalizedInfo = {};
            if (title) {
                const { orionAlias } = data;
                const normalizedAlias = orionAlias &&
                    orionAlias.charAt(0).toUpperCase() + orionAlias.slice(1);
                normalizedInfo.alias = normalizedAlias;
                normalizedInfo.carouselClassName = `Carousel ${normalizedAlias}`;
                normalizedInfo["Text-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Text-1"]), { text: title });
            }
            if (img) {
                normalizedInfo["Image"] = img;
            }
            if (urlLink && buttonText) {
                normalizedInfo["Button-1"] = Object.assign(Object.assign({}, mocks_json_1.default["Button-1"]), { label: buttonText, href: urlLink });
            }
            if (layout) {
                normalizedInfo.layout = layout;
            }
            if (backgroundColor) {
                normalizedInfo.backgroundColor = backgroundColor;
            }
            normalizedInfo.name = data === null || data === void 0 ? void 0 : data.name;
            listadoCards.map((card, index) => {
                var _a, _b;
                const { fields } = card;
                const button = fields === null || fields === void 0 ? void 0 : fields["COMPONENT_BASIC-BUTTON"];
                if ((fields === null || fields === void 0 ? void 0 : fields.title) && (fields === null || fields === void 0 ? void 0 : fields.description)) {
                    const titleText = fields.title;
                    const title = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-1"]), { text: titleText });
                    const altImg = fields.altSEO || titleText;
                    const titleImg = fields.titleSEO || titleText;
                    const category = fields.category;
                    const description = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Text-2"]), { text: fields.description });
                    const image = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["Image-1"]), { src: fields.img || "", alt: altImg, title: titleImg });
                    if (button && ((_a = button.fields) === null || _a === void 0 ? void 0 : _a.label) && ((_b = button.fields) === null || _b === void 0 ? void 0 : _b.href)) {
                        const customLink = Object.assign(Object.assign({}, mocks_json_1.default["Charac"]["CustomLink-1"]), { href: button.fields.href });
                        normalizedInfo[`Card-${index + 1}`] = {
                            "Image-1": image,
                            "Text-1": title,
                            "Text-2": description,
                            "Button-1": button.fields,
                            "CustomLink-1": customLink,
                            categories: category || [],
                        };
                    }
                    else {
                        normalizedInfo[`Card-${index + 1}`] = {
                            "Image-1": image,
                            "Text-1": title,
                            "Text-2": description,
                            categories: category || [],
                        };
                    }
                }
            });
            res = normalizedInfo;
        }
        return res;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
exports.recomNormalizer = recomNormalizer;
exports.default = exports.recomNormalizer;
//# sourceMappingURL=index.js.map